import * as React from 'react';
import { SelectInput } from 'src/latest/src/components';
import './TherapistSearch.scss';
import { getPracticeAdminUsersV1 } from '../../../../api/user';
import _ from 'lodash';

export default function TherapistSearch({ onSelected }) {
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  // Tracks the latest input so stale API responses are discarded
  const latestInput = React.useRef('');

  const fetchTherapists = async searchString => {
    const requestPayload = {
      user_type: 'THERAPIST',
      keyword: searchString,
    };

    setLoading(true);
    const { users } = await getPracticeAdminUsersV1(requestPayload);

    // Discard response if the user has already changed/cleared the input
    if (latestInput.current === searchString) {
      setOptions(users);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (inputValue && inputValue.length > 2) {
      fetchTherapists(inputValue);
    } else {
      setOptions([]);
    }
  }, [inputValue]);

  React.useEffect(() => {
    onSelected(value);
  }, [value]);

  // useRef prevents a new debounce instance being created on every render
  const onChangeInputValue = React.useRef(
    _.debounce(newInputValue => {
      setInputValue(newInputValue);
    }, 500),
  ).current;

  return (
    <div className="therapist-autocomplete-search">
      <SelectInput
        inputId="therapist-search"
        placeholder="Search therapists"
        options={options}
        value={value}
        getOptionLabel={option => option.full_name || option.email}
        getOptionValue={option => option.email}
        filterOption={null}
        isLoading={loading}
        isClearable={true}
        menuZIndex={99}
        width={270}
        noOptionsMessage={() =>
          inputValue.length <= 2 ? 'Type to search' : 'No therapist'
        }
        onChange={newValue => {
          setValue(newValue);

          if (!newValue) {
            latestInput.current = '';
            setOptions([]);
            setInputValue('');
            setLoading(false);
          }
        }}
        onInputChange={(newInputValue, { action }) => {
          if (action === 'input-change') {
            latestInput.current = newInputValue;
            setOptions([]);
            setLoading(false);
            onChangeInputValue(newInputValue);
          }
        }}
      />
    </div>
  );
}
